import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

export enum SupportType {
  tutoring = 'tutoring',
}

type SupportRecipientFiltersType = {
  type: SupportType;
  [key: string]: unknown;
};

type FindSupportRecipientParams = {
  userId: number;
  filters: SupportRecipientFiltersType;
};

const { useFind: useSupportRecipient } = getCRUDHooks({
  entityName: 'supportRecipients',
  find({ userId, filters }: FindSupportRecipientParams) {
    return clientApi.getOCClient().helpers.user.users.id(userId).supportRecipients.find(filters);
  },
});

export { useSupportRecipient };
